import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { resetAcountOverview } from "../redux/slices/accountOverviewSlice"
import { resetProjects } from "../redux/slices/projectsSlice"

const useShowErrorOnMetricsRequestFailure = () => {
    const { error } = useSelector((state) => state.fetchStatus)
    const dispatch = useDispatch()
    useEffect(() => {
        if(!error) return 
        const errorHandler = new window.AlertHandler()
        errorHandler.showAlertV2 = errorHandler.handleAlert
        dispatch(resetAcountOverview())
        dispatch(resetProjects())
        errorHandler.showAlertV2("error", error.message, true, 10000)
    }, [error])
}

export default useShowErrorOnMetricsRequestFailure